import ICoupon from "~/interfaces/ICoupon"
import { activeDatesTypes, BOOKING_DATES_EXPIRATION, discountTypes, expirationByOptions } from "~/constants/coupons"

export const defineDiscountType = (coupon: ICoupon) => {
  if (typeof coupon?.subtotal_amount_off_in_cents === "number") {
    return discountTypes[1]
  } else if (typeof coupon?.amount_off_in_cents === "number") {
    return discountTypes[2]
  } else if (typeof coupon?.flat_rate_in_cents === "number") {
    return discountTypes[3]
  }

  return discountTypes[0]
}

export const defineActiveDateType = (coupon: ICoupon) => {
  if (coupon?.valid_from?.length && coupon?.valid_until?.length) {
    return activeDatesTypes[1]
  }

  return activeDatesTypes[0]
}

export const defineExpirationBy = (coupon: ICoupon) => {
  if (coupon?.expiration_by === BOOKING_DATES_EXPIRATION) {
    return expirationByOptions[1]
  }

  return expirationByOptions[0]
}
